module.exports = __webpack_public_path__ + "static/media/admin-mentoring.790fb0cf.svg";